import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import toggle from 'components/common/hoc/toggle'
import withComponentRef from 'components/common/hoc/withComponentRef'
import { getFiltersData, getSortOptions, getAllSelectedFilters } from '../../selectors'
import { showFilterModal, hideFilterModal } from 'actions/filterModal'
import { filterItems, resetFilters } from '../../actions'
import FiltersModal from './FiltersModal'

const withFilterModalHandlers = withHandlers({
  handleFilterModalShow: ({ navigation, showFilterModal }) => () =>
    showFilterModal({ data: navigation }),

  handleFilterModalHide: ({ hideFilterModal, getComponentDOMNode }) => () => {
    hideFilterModal()
    window.scrollTo(0, getComponentDOMNode().offsetTop - 200) // 200 is additional offset to compensate sticky header
  }
})

const mapStateToProps = state => {
  const { navigation } = getFiltersData(state)
  const selectedFilters = getAllSelectedFilters(state)
  const sortOptions = getSortOptions(state)

  return {
    navigation,
    selectedFilters,
    sortOptions
  }
}

export default compose(
  toggle,
  connect(mapStateToProps, { filterItems, resetFilters, showFilterModal, hideFilterModal }),
  withComponentRef,
  withFilterModalHandlers
)(FiltersModal)
